import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { FatturazioneConfermaComponent } from './fatturazione-conferma';

export const FatturazioneConfermaModule: string = ng
    .module('fatturazione-conferma', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('fatturazioneConfermaComponent', FatturazioneConfermaComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/fatturazione-conferma/fatturazione-conferma.module.ts